import { render } from "./Farms.vue?vue&type=template&id=661bb585"
import script from "./Farms.vue?vue&type=script&lang=js"
export * from "./Farms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__